import GoToPage from "./GoToPage";

export default GoToPage;
